import { Search, Menu, X } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useState, useEffect } from "react";

const navItems = [
  { label: "トップ", path: "/" },
  { label: "動画", path: "/feed" },
  { label: "セール", path: "/sale" },
  { label: "カップ別", path: "/cup/E" },
  { label: "バスト別", path: "/bust/90-95" },
  { label: "ウエスト別", path: "/waist/55-60" },
  { label: "ヒップ別", path: "/hip/85-90" },
  { label: "新着", path: "/?sort=newest" },
];

export function Header() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  // Close mobile menu when location changes
  useEffect(() => {
    setIsMobileMenuOpen(false);
  }, [location]);

  function isActive(path: string) {
    if (path === "/") return location.pathname === "/" && !location.search.includes("sort=newest");
    if (path.includes("?sort=newest")) return location.search.includes("sort=newest");
    if (path === "/feed") return location.pathname === "/feed";
    if (path === "/sale") return location.pathname === "/sale";
    if (path.startsWith("/cup")) return location.pathname.startsWith("/cup");
    if (path.startsWith("/bust")) return location.pathname.startsWith("/bust");
    if (path.startsWith("/waist")) return location.pathname.startsWith("/waist");
    if (path.startsWith("/hip")) return location.pathname.startsWith("/hip");
    return location.pathname === path;
  }

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  return (
    <>
      <header className="w-full h-[72px] bg-card border-b border-border flex items-center justify-between px-4 md:px-8 lg:px-16">
        <Link to="/" className="font-[var(--font-primary)] text-xl font-bold text-foreground no-underline">
          ACTRESS DB
        </Link>
        
        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center gap-8">
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`font-[var(--font-secondary)] text-sm no-underline transition-colors ${
                isActive(item.path)
                  ? "text-primary font-semibold"
                  : "text-muted-foreground hover:text-foreground"
              }`}
            >
              {item.label}
            </Link>
          ))}
          <Link to="/?focus=search" className="text-muted-foreground hover:text-foreground">
            <Search size={20} />
          </Link>
        </nav>

        {/* Mobile Hamburger Button */}
        <button
          className="md:hidden text-foreground p-2"
          onClick={() => setIsMobileMenuOpen(true)}
          aria-label="メニューを開く"
        >
          <Menu size={24} />
        </button>
      </header>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <>
          <div 
            className="fixed inset-0 bg-black/50 z-40 md:hidden"
            onClick={closeMobileMenu}
          />
          <div className="fixed top-0 right-0 bottom-0 w-[280px] bg-card z-50 md:hidden shadow-lg">
            <div className="flex items-center justify-between p-4 border-b border-border">
              <span className="font-[var(--font-primary)] text-lg font-bold text-foreground">
                メニュー
              </span>
              <button
                onClick={closeMobileMenu}
                className="text-foreground p-2"
                aria-label="メニューを閉じる"
              >
                <X size={24} />
              </button>
            </div>
            <nav className="flex flex-col p-4">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMobileMenu}
                  className={`font-[var(--font-secondary)] text-base no-underline py-3 px-2 transition-colors ${
                    isActive(item.path)
                      ? "text-primary font-semibold"
                      : "text-muted-foreground hover:text-foreground"
                  }`}
                >
                  {item.label}
                </Link>
              ))}
              <Link 
                to="/?focus=search" 
                onClick={closeMobileMenu}
                className="flex items-center gap-2 text-muted-foreground hover:text-foreground py-3 px-2 transition-colors"
              >
                <Search size={20} />
                <span className="font-[var(--font-secondary)] text-base">検索</span>
              </Link>
            </nav>
          </div>
        </>
      )}
    </>
  );
}
